/* eslint-disable @typescript-eslint/no-unused-vars */
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { UtilsAction } from './utils.actions';
import { Store } from '@ngrx/store';
import { filter, share, tap } from 'rxjs/operators';
import { AppState } from '../../interfaces/app-state.interface';
import { UtilitiesService } from '../../services/utilities.service';
import { RealtimeService } from '../../services/realtime/realtime.service';
import { RealtimeHub } from '../../enum/realtime/realtime-hub.enum';
import { Action } from '@ngrx/store';

@Injectable()
export class UtilsEffects {
  constructor(
    private actions$: Actions<UtilsAction>,
    private realtimeService: RealtimeService,
    private store: Store<AppState>,
    private utils: UtilitiesService
  ) {}

  getTimer$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(UtilsAction.getTimer),
        filter(
          (action) =>
            this.realtimeService.registerSubscribersAndCheckIfSubscriptionIsNeeded(
              RealtimeHub.Time
            ) === true
        ),
        tap((action) => {
          this.realtimeService
            .subscribeToTimeInfo()
            .pipe(filter((i) => !!i))
            .subscribe((body) => {
              const time = body.DateTime ? body.DateTime.split(' ')[1] : '';
              this.onIncomingData({
                type: UtilsAction.getTimerSuccess,
                payload: time,
              } as UtilsAction);
              this.onIncomingData({
                type: UtilsAction.getDateTimeSuccess,
                payload: body.DateTime,
              } as UtilsAction);
            });
        }),
        share()
      ),
    { dispatch: false }
  );

  private onIncomingData(action: Action) {
    this.store.dispatch(action);
  }
}